export default {"src":"/_next/static/media/trending.eb1d5c04.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};